import { render, staticRenderFns } from "./LinkInput.vue?vue&type=template&id=520a560a&scoped=true"
import script from "./LinkInput.vue?vue&type=script&lang=js"
export * from "./LinkInput.vue?vue&type=script&lang=js"
import style0 from "./LinkInput.vue?vue&type=style&index=0&id=520a560a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520a560a",
  null
  
)

export default component.exports